import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { PLACEHOLDER_TESTIMONIALS } from './salesData';

/**
 * MAQUETA VISUAL — PLACEHOLDER TESTIMONIALS.
 *
 * Los nombres, países y textos de PLACEHOLDER_TESTIMONIALS son ficticios y
 * están aquí sólo para poder ver la landing terminada. Se reemplazan por
 * testimonios auténticos editando únicamente ese array (iniciales/avatar,
 * nombre, país y texto), sin tocar este componente.
 *
 * NO usar en Schema Review, AggregateRating, SEO, metadatos, anuncios ni
 * contadores de clientes. No se presentan como compra verificada ni se
 * derivan estadísticas de ellos.
 */
export function TestimonialsSection() {
  return <section className="overflow-hidden bg-cream py-14 sm:py-20" aria-labelledby="testimonials-title" data-id="element-359" data-mp="1831k2h8yfd1q">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-360" data-mp="2yd354ralzfc5">
        <div className="max-w-2xl" data-id="element-361" data-mp="32frgb5msoyca">
          <SectionTag data-id="element-362" data-mp="32eoo8udqkpus">Lo que imaginan</SectionTag>
          <h2 id="testimonials-title" className="mt-4 font-display text-[1.95rem] leading-[1.06] text-charcoal sm:text-[2.7rem]" data-id="element-363" data-mp="2v0sth5mdry1s">
            Personas que ya se imaginan todo lo que pueden crear
          </h2>
          <p className="mt-4 font-sans text-[0.95rem] leading-relaxed text-charcoal-mid" data-id="element-364" data-mp="34tgqo1h9w411">
            Desde quienes están dando sus primeros pasos hasta quienes buscan sumar nuevas opciones
            a su catálogo.
          </p>
        </div>

        <ul className="no-scrollbar mt-9 flex snap-x snap-mandatory gap-4 overflow-x-auto pb-2 sm:grid sm:grid-cols-2 sm:gap-5 sm:overflow-visible lg:grid-cols-3" data-id="element-365" data-mp="27458j3lm63lc">
          {PLACEHOLDER_TESTIMONIALS.map((item, index) => <motion.li key={item.id} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(index, 4) * 0.03
        }} className="flex w-[78%] shrink-0 snap-start flex-col rounded-4xl border border-warm bg-ivory p-5 sm:w-auto sm:p-6" data-id="element-366" data-mp="2h108lqxjcc1q" data-mpi={index}>
              <div className="flex items-center gap-1" aria-label="5 de 5 estrellas" data-id="element-367" data-mp="ddhpcsjm4vna">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-3.5 w-3.5 fill-[#F47A2A] text-[#F47A2A]" aria-hidden data-id="element-368" data-mp="3gtx4cmii5q55" data-mpi={star} />)}
              </div>

              <p className="mt-3.5 flex-1 font-sans text-[0.88rem] leading-relaxed text-charcoal" data-id="element-369" data-mp="3qqthx6n9d2gk">
                “{item.quote}”
              </p>

              <div className="mt-5 flex items-center gap-3 border-t border-warm pt-4" data-id="element-370" data-mp="3vke8idmiuu5q">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-caramel-pale font-sans text-[0.72rem] font-bold text-[#F47A2A]" aria-hidden data-id="element-371" data-mp="2y132mu9w3uiv">
                  {item.initials}
                </span>
                <div data-id="element-372" data-mp="1g6c403w09d3p">
                  <p className="font-sans text-[0.84rem] font-bold leading-tight text-charcoal" data-id="element-373" data-mp="1g3pysawl79on">
                    {item.name}
                  </p>
                  <p className="font-sans text-[0.76rem] leading-tight text-charcoal-mid" data-id="element-374" data-mp="166bj4dihmoxe">
                    {item.country}
                  </p>
                </div>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}